import {ContentItemEntity} from './content-item.entity';


export class ContentContainerEntity{
    public listOfContentItemEntity: ContentItemEntity[] = [];
    public addContentItem(contentItemEntity: ContentItemEntity): void{
        this.listOfContentItemEntity.push(contentItemEntity);
    }

}